<script lang="ts" context="module">
  export const magicLinkModal = new ModalState('magic-link');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import Send from '~icons/mdi/send';
  import Magic from '~icons/mdi/auto-fix';

  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { magicLinkMutation } from './mutations.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import ValidationError from './ValidationError.svelte';
  import { validateEmail } from './utils';
  import type { ChangeEventHandler } from 'svelte/elements';

  const magicLink = magicLinkMutation();
  let emailRef: HTMLInputElement;
  let validationError: string | undefined = undefined;

  // const handleBack = () => {
  //   signinModal.replace();
  // }

  const handleClose = () => {
    magicLink.reset();
    magicLinkModal.pop();
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    validationError = validateEmail((e.target as HTMLInputElement).value);
  };

  const handleMagicLink = async (e: SubmitEvent) => {
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const email = formData.get('email') as string;
    validationError = validateEmail(email);
    if (validationError) return;
    magicLink.mutate({ email });
  };
</script>

<Modal
  open={magicLinkModal.value !== undefined}
  onClose={handleClose}
  index={7}
>
  {#snippet title()}
    <Magic />Send Magic Link
  {/snippet}
  {#snippet content()}
    {#if magicLink.isSuccess}
      <h3 class="success status">Email Sent!</h3>
    {:else}
      <p>Send a magic link to the email you used to signup.</p>
      {#if magicLink.error}
        <ValidationError error={magicLink.error.message} />
      {:else if validationError}
        <ValidationError error={validationError} />
      {/if}
      <form
        id="reset-password-form"
        class="auth-form"
        novalidate
        on:submit|preventDefault={handleMagicLink}
      >
        <input
          bind:this={emailRef}
          on:change={handleChange}
          type="email"
          name="email"
          placeholder="email"
          value={magicLinkModal.value}
        />
      </form>
    {/if}
  {/snippet}
  {#snippet controls()}
    <div class="signup-container">
      {#if magicLink.isSuccess}
        <ActionButton onClick={handleClose}><Close />Back</ActionButton>
      {:else}
        <ActionButton onClick={handleClose}><Close />Back</ActionButton>
        <ActionButton
          form="reset-password-form"
          type="submit"
          disabled={magicLink.isPending}
          ><Send />
          {#if magicLink.isPending}
            Sending...
          {:else}
            Send Email
          {/if}
        </ActionButton>
      {/if}
    </div>
  {/snippet}
</Modal>

<style lang="scss">
  @use '../theme/theme.scss';
  @use 'sass:color';

  .signup-container {
    display: grid;
    grid-auto-flow: column;
    gap: 0.5em;
  }
  .status {
    display: block;
    width: 100%;
    font-weight: bold;
    text-align: center;
    padding: 0.5em;
    border-radius: 2px;
    margin: 0 0 0.5em 0;
    color: white;
  }
  .success {
    background-color: color.adjust(theme.$star-bonus, $alpha: 0.5);
  }
</style>
